import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import {
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDivider } from '@angular/material/divider';
import { RouterLink } from '@angular/router';
import { MainRoute, RootRoute } from '../../../models/angular-routing';
import { InsightsRoute } from '../../../../pages/insights/insights.routes';
import { StormService } from '../../../../data/storms/storm.service';
import { ToastService } from '../../../services/toast.service';
import { DatePipe, NgClass, NgStyle } from '@angular/common';
import { ConfigurationModel, StormStatus } from '../../../models/configuration.model';
import { ConfigurationService } from '../../../../configuration/configuration.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-storm-menu',
  imports: [
    MatMenuTrigger,
    MatTooltip,
    MatIcon,
    MatMenu,
    ReactiveFormsModule,
    MatDivider,
    MatMenuItem,
    RouterLink,
    NgStyle,
    NgClass,
    DatePipe,
  ],
  templateUrl: './storm-menu.component.html',
  styleUrl: './storm-menu.component.scss',
})
export class StormMenuComponent implements OnInit, OnChanges {
  @Input() configuration: ConfigurationModel;
  stormStatus: StormStatus;
  isMenuOpened = false;

  protected readonly RootRoute = RootRoute;
  protected readonly MainRoute = MainRoute;
  protected readonly InsightsRoute = InsightsRoute;

  constructor(
    private readonly configurationService: ConfigurationService,
    private readonly stormService: StormService,
    private readonly toast: ToastService,
    private readonly dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.stormStatus = this.configuration.otherSettings.stormStatus;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.stormStatus = this.configuration.otherSettings.stormStatus;
  }

  onMenuClosed() {
    this.isMenuOpened = false;
  }

  onMenuOpened() {
    this.isMenuOpened = true;
  }

  startStorm() {
    const ref = this.dialog.open(ConfirmationDialogComponent, {
      width: '450px',
      data: {
        text: 'Starting a new Storm Event - The Live Map and Statistics will now be cleared.',
      },
    });

    firstValueFrom(ref.afterClosed()).then(result => {
      if (result) {
        this.stormStatus.active = true;
        this.stormStatus.eventCreated = new Date();
        this.configurationService
          .updateStormStatus(this.stormStatus)
          .then(() => {
            this.configurationService.resetContent(new Date()).then(() => {
              this.configurationService.refreshConfiguration();
            });
          })
          .catch(error => {
            console.error(error);
            this.toast.long('Storm Event could not be started!');
            this.stormStatus.active = false;
            this.stormStatus.eventCreated = undefined;
          });
      }
    });
  }

  endStorm() {
    const endedStormRequest = {
      active: false,
    } as StormStatus;
    const startDate = new Date(this.stormStatus.eventCreated);
    const endDate = new Date();
    const name =
      startDate.toLocaleString('en-US', { month: 'short' }) +
      ' ' +
      String(startDate.getDate()).padStart(2, '0') +
      ', ' +
      startDate.getFullYear();

    this.configurationService
      .updateStormStatus(endedStormRequest)
      .then(() => {
        this.stormService
          .createStorm(name, startDate, endDate)
          .then(() => {
            this.configurationService.resetContent(null).then(() => {
              this.configurationService.refreshConfiguration();
            });
            this.stormStatus.active = false;
            this.stormStatus.eventCreated = undefined;
            this.toast.short('Storm Event has been created.');
          })
          .catch(error => {
            console.error(error);
            this.toast.long('Storm Event could not be finalized!');
          });
      })
      .catch(error => {
        console.error(error);
        this.stormStatus = this.configuration.otherSettings.stormStatus;
        this.configurationService.refreshConfiguration();
        this.toast.long('Storm Event could not be finalized!');
      });
  }
}
